import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updatePageContext } from '@amzn/a3c-runtime-sdk';
import { AdsAgentChatEventType, subscribeToAdsAgentChatEvents } from '@amzn/a3-chat-event-sdk';
import { clearAnalysisReportName, resetCanvas } from '@flexible-reports/store/slices/analysis-workspace/analysis-workspace-slice';
import { isAnalysisWorkspaceEnabled } from '@flexible-reports/utils/app-utils';

/**
 * Sends a one-shot `resetCanvasState` flag via non-persistent page context on mount.
 * This informs the agent that the canvas is empty after a page reload, so it should
 * disregard stale add/update widget tool calls from prior chat history.
 *
 * Also clears the canvas redux state when a new chat starts.
 *
 * Only active when the analysis workspace feature is enabled.
 */
export const useResetCanvasPageContext = (): void => {
  const dispatch = useDispatch();
  const workspaceEnabled = isAnalysisWorkspaceEnabled();

  useEffect(() => {
    if (!workspaceEnabled) return;
    updatePageContext({ resetCanvasState: true }, { persistent: false });
  }, [workspaceEnabled]);

  useEffect(() => {
    if (!workspaceEnabled) return;
    return subscribeToAdsAgentChatEvents(AdsAgentChatEventType.NEW_CHAT, () => {
      dispatch(resetCanvas());
      dispatch(clearAnalysisReportName());
    });
  }, [dispatch, workspaceEnabled]);
};
